type InfoHeaderProps = {
  header: string;
  description: string;
};

const InfoHeader = ({ header, description }: InfoHeaderProps) => {
  return (
    <div className="prose text-gray-400">
      <h4 className="font-bold font-noto-sans text-gray-500 mb-0 text-xl">
        {header}
      </h4>
      <p>{description}</p>
    </div>
  );
};
export default InfoHeader;
